"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagService = void 0;
const tslib_1 = require("tslib");
const store_1 = require("../store");
const index_1 = require("./index");
class TagService {
    constructor() {
        this.__priority = 100;
    }
    refresh(tagIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield store_1.AppStore.Tag.refresh();
            const promises = [];
            for (const tagId of tagIds) {
                promises.push(store_1.AppStore.TagSummary.getFetchable(tagId).refetch());
            }
            yield Promise.all(promises);
            return index_1.Services.Search.search();
        });
    }
    rename(tagId, newName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = index_1.Services.Department.rest;
            let tag = store_1.AppStore.Tag.get(tagId);
            tag.name = newName;
            const newTagJson = yield rest.save(rest.Objects.Tag, tag);
            yield this.refresh([newTagJson.objectId]);
            return newTagJson;
        });
    }
}
exports.TagService = TagService;
//# sourceMappingURL=tag.service.js.map